(function(){try{
  /* Case 56 - Gift Box gifting controller (Website 2.0 DEV). Loaded by layout/theme.liquid only on product
     pages in the "All Gift boxes" collection (id 279697096748). On those pages it replaces the Globo option
     set UI (hidden by html.saga-gb-on, see assets/saga-giftbox.css; the Globo app and its option sets are
     untouched) with the Saga gift flow the Christmas stockings use (assets/saga-stocking-gift.js, unchanged):
     item-by-item name embroidery, gift wrapping and a card, chosen per gift box. The card part is the stocking
     code, kept identical so both pages look and behave the same. No customer-visible text lives here:
     everything comes from window.SagaI18n (locales/*.json).

     PERSONALISATION comes from product data, never from this file: the list metafield
     corporate.personalisation_options (for example ["Blue Bib","Cream Bib"]). layout/theme.liquid turns each
     entry into {item, prop, phrase, label}: prop is the canonical English order key ("Blue bib name"),
     phrase/label the translated wording ("den blå hagesmæk" / "Personliggør den blå hagesmæk ♡"). Each ticked
     item adds one Name Embroidery line (product name-embroidery, SKU GB-NAME-EMB) at its live price.
     Fail closed: when that product cannot be resolved, window.SagaGift.name is null and no personalisation is
     offered, so embroidery can never be added for free. A ticked item needs a name (max. 12 characters).

     WRAPPING (Case 56b): gift boxes sell all year, so each box has three exclusive choices - no wrapping,
     Classic Wrapping (Gaveindpakning) or Christmas Wrapping (Juleindpakning). Both styles are the same 35 kr
     `wrap` add-on line, told apart by Wrapping style; their photos come from snippets/saga-gift-options.liquid
     (part wraps), the same list the cart thumbnails read. Nothing is pre-selected.

     CART CONTRACT (same shape as the stockings, README Case 35/56). Property names and values are canonical
     English order data; the cart page translates the display only. Visible properties first, hidden last
     (the Shipmondo pick list drops keys starting with "_"):
       box line   Gift (Gift box n), <Item> name (one per named item), Gift wrapping (Yes/No), Wrapping style
                  (Classic Wrapping / Christmas Wrapping), Greeting card (Yes/No), Card name, Card no.,
                  Card message, To, From, Greeting, _saga_names (the <Item> name keys, "|"-separated), _saga_gift_id
       name line  product name-embroidery, quantity 1 per named item: For, <Item> name, _saga_item (the key),
                  _saga_gift_id, _saga_addon=name
       wrap line  For, Wrapping style, _saga_gift_id, _saga_addon=wrap
       card line  For, Card name, Card no., Card message, To, From, Greeting, _saga_gift_id, _saga_addon=card
     A box with no extras is added with no properties, so identical plain boxes still merge into one line.
     "Gift box n" is unique across the whole cart (the cart is read first). assets/saga-gift-sync.js keeps the
     add-on lines consistent with their box when the cart changes afterwards. */
  var T=window.SagaI18n,R=window.SagaRoutes||{},G=window.SagaGift,H=document.documentElement;
  function bail(){try{H.classList.remove('saga-gb-on');}catch(x){}}
  if(!T||!G||!G.giftbox){bail();return;}
  var NS='http://www.w3.org/2000/svg',MAXQ=20,MAXN=12;
  /* canonical order-data vocabulary (not display copy, see CART CONTRACT) */
  var DATA={box:'Gift box ',wraps:{classic:'Classic Wrapping',christmas:'Christmas Wrapping'},cardHandwritten:'Handwritten',cardBlank:'Blank card – customer writes it'};
  G.cards=G.cards||[];
  var ITEMS=G.name&&G.items?G.items:[];
  var STYLES=(G.wrapStyles||['classic','christmas']).filter(function(k){return Object.prototype.hasOwnProperty.call(DATA.wraps,k);});

  /* Liquid's t filter HTML-escapes non-_html keys ("it&#39;s"); decode once, text is only ever set via textContent */
  var dec=document.createElement('textarea');
  function t(k){dec.innerHTML=String(T[k]==null?'':T[k]);return dec.value;}
  function fill(s,map){s=String(s);for(var k in map){if(Object.prototype.hasOwnProperty.call(map,k))s=s.split(k).join(map[k]);}return s;}
  function isAddForm(f){return !!f&&/[/]cart[/]add([?#]|$)/.test(f.getAttribute('action')||'');}
  function addForms(){var out=[],fs=document.querySelectorAll('form[action]'),i;for(i=0;i<fs.length;i++)if(isAddForm(fs[i]))out.push(fs[i]);return out;}
  function inAddForms(sel){var fs=addForms(),i,e;for(i=0;i<fs.length;i++){e=fs[i].querySelector(sel);if(e)return e;}return null;}
  function shopRoot(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function cartUrl(){return R.cart||(shopRoot()+'cart');}
  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;}
  function lines(node,text){String(text).split(/<br\s*\/?>/i).forEach(function(part,i){if(i)node.appendChild(document.createElement('br'));node.appendChild(document.createTextNode(part));});return node;}
  /* shop.money_format of the active currency; whole amounts drop their decimals ("99 kr") */
  function money(cents){
    var f=G.moneyFormat||'{{amount}}',m=f.match(/\{\{\s*(\w+)\s*\}\}/);
    function num(d,ts,ds){if(cents%100===0)d=0;var p=(cents/100).toFixed(d).split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return p[1]?p[0]+ds+p[1]:p[0];}
    if(!m)return num(2,',','.');
    var v={amount:num(2,',','.'),amount_no_decimals:num(0,',','.'),amount_with_comma_separator:num(2,'.',','),
      amount_no_decimals_with_comma_separator:num(0,'.',','),amount_with_apostrophe_separator:num(2,"'",'.'),
      amount_no_decimals_with_space_separator:num(0,' ',','),amount_with_space_separator:num(2,' ',',')}[m[1]];
    return f.replace(m[0],v==null?num(2,',','.'):v);
  }
  function icon(){
    var s=document.createElementNS(NS,'svg');
    s.setAttribute('viewBox','0 0 40 40');s.setAttribute('aria-hidden','true');s.setAttribute('focusable','false');
    s.setAttribute('fill','none');s.setAttribute('stroke','currentColor');s.setAttribute('stroke-width','1.4');s.setAttribute('stroke-linecap','round');s.setAttribute('stroke-linejoin','round');
    ['M9 11h22v18H9Z','M9 11l11 9 11-9','M8 7l24 27'].forEach(function(p){var pa=document.createElementNS(NS,'path');pa.setAttribute('d',p);s.appendChild(pa);});
    return s;
  }
  function cardByCode(code){var i;for(i=0;i<G.cards.length;i++)if(G.cards[i].code===code)return G.cards[i];return null;}

  var form=document.querySelector('form.product-purchase-form');
  if(!isAddForm(form)){
    form=null;
    var cand=addForms(),c;
    for(c=0;c<cand.length;c++){if(cand[c].querySelector('button[type="submit"],button[name="add"]')){form=cand[c];break;}}
  }
  if(!form||(!ITEMS.length&&!G.wrap&&!G.card)){bail();return;}
  var qtyInput=form.querySelector('input[name="quantity"]')||document.getElementById('quantity');
  var units=[],giftRoot=null,giftErr=null;

  function variantId(){
    var e=form.querySelector('input[name="id"],select[name="id"]')||inAddForms('input[name="id"],select[name="id"]');
    if(e&&e.value)return Number(e.value);
    try{return Number(window.ShopifyAnalytics.meta.selectedVariantId||window.ShopifyAnalytics.meta.product.variants[0].id);}catch(x){return null;}
  }
  function rawQty(){var n=parseInt(qtyInput&&qtyInput.value,10);return isNaN(n)||n<1?1:n;}
  function qty(){return Math.min(rawQty(),MAXQ);}
  function ensureUnits(n){
    while(units.length<n){
      var nm=[],j;for(j=0;j<ITEMS.length;j++)nm.push({on:false,name:''});
      units.push({names:nm,wrap:'none',card:'',mode:'handwritten',to:'',from:'',greeting:'',open:false});
    }
  }
  function labelFor(i){return fill(t('boxN'),{'%n':String(i+1)});}
  function namedOf(i){
    var u=units[i],out=[];if(!u)return out;
    ITEMS.forEach(function(it,j){var s=u.names[j];if(s&&s.on)out.push({item:it,name:String(s.name||'').trim(),j:j});});
    return out;
  }
  function wrapOf(u){return G.wrap&&u&&u.wrap!=='none'&&STYLES.indexOf(u.wrap)>-1?u.wrap:'';}
  function hasChoice(i){var u=units[i];return !!u&&(namedOf(i).length>0||!!wrapOf(u)||(!!G.card&&!!u.card));}
  function anyChoice(){var n=qty(),i;for(i=0;i<n;i++)if(hasChoice(i))return true;return false;}
  function setErr(node,m){if(!node)return;node.textContent=m||'';node.hidden=!m;}

  function head(sec,title,price){var h=el('div','saga-gift__head');h.appendChild(el('p','saga-gift__eye',title));if(price)h.appendChild(el('p','saga-gift__price',price));sec.appendChild(h);}
  function radio(name,value,checked){var r=el('input');r.type='radio';r.name=name;r.value=value;if(checked)r.checked=true;return r;}
  function img(src){var im=el('img');im.src=src;im.alt='';im.loading='lazy';return im;}
  function checkbox(checked,onchange){var c=el('input');c.type='checkbox';c.checked=!!checked;c.addEventListener('change',function(){onchange(c.checked);});return c;}

  /* ---- personalisation: one row per item in the box, "Personalise the blue bib ♡ / +99 kr / [name]" ---- */
  function nameRow(i,j){
    var it=ITEMS[j],st=units[i].names[j];
    var box=el('div','saga-gb__item'+(st.on?' is-on':'')),lab=el('label','saga-gb__opt'),field=el('div','saga-gb__namefield'),inp=el('input','saga-gb__name');
    lab.appendChild(checkbox(st.on,function(on){
      st.on=on;box.classList.toggle('is-on',on);field.hidden=!on;setErr(giftErr,'');
      if(on)inp.focus();else inp.classList.remove('is-missing');
    }));
    var txt=el('span','saga-gb__opttext');
    txt.appendChild(el('span','saga-gb__optlabel',it.label));
    txt.appendChild(el('span','saga-gb__optprice',fill(t('nameAdd'),{'%p':money(G.name.price)})));
    lab.appendChild(txt);box.appendChild(lab);
    field.hidden=!st.on;
    inp.type='text';inp.value=st.name;inp.placeholder=t('namePlaceholder');
    inp.setAttribute('maxlength',String(MAXN));inp.setAttribute('autocomplete','off');
    inp.setAttribute('aria-label',it.label);inp.setAttribute('data-name',i+'-'+j);
    inp.addEventListener('input',function(){st.name=inp.value;inp.classList.remove('is-missing');setErr(giftErr,'');});
    field.appendChild(inp);
    field.appendChild(el('span','saga-gb__help',fill(t('nameHelp'),{'%m':String(MAXN)})));
    box.appendChild(field);
    return box;
  }
  function namesSection(n){
    var sec=el('div','saga-gift__sec saga-gb__sec'),i,j;
    head(sec,t('nameTitle'),fill(t('priceEachName'),{'%p':money(G.name.price)}));
    sec.appendChild(el('p','saga-gift__lead',t('nameLead')));
    for(i=0;i<n;i++){
      if(n>1)sec.appendChild(el('p','saga-gb__box',labelFor(i)));
      var list=el('div','saga-gb__items');
      for(j=0;j<ITEMS.length;j++)list.appendChild(nameRow(i,j));
      sec.appendChild(list);
    }
    return sec;
  }

  /* ---- gift wrapping (Case 56b): "No wrapping", then Gift wrapping and Christmas wrapping side by side ---- */
  function wrapName(k){return t(k==='classic'?'wrapClassic':'wrapChristmas');}
  function wrapTile(k,input){
    var tile=el(input?'label':'div','saga-gb__wraptile'),src=G.wrap.images&&G.wrap.images[k];
    tile.setAttribute('data-wrap',k);
    if(src){var th=el('span','saga-gb__wrapimg');th.appendChild(img(src));tile.appendChild(th);}
    var ch=el('span','saga-gb__wrapchoice');
    if(input)ch.appendChild(input);
    ch.appendChild(el('span','saga-gb__wrapname',wrapName(k)));
    tile.appendChild(ch);
    tile.appendChild(el('span','saga-gb__wrapprice',money(G.wrap.price)));
    return tile;
  }
  /* one gift box: three radios in one group, so only one wrapping choice is possible */
  function wrapChoices(i){
    var box=el('div','saga-gb__wrap'),group='saga-wrap-'+i,grid=el('div','saga-gb__wraps');
    box.setAttribute('role','radiogroup');box.setAttribute('aria-label',t('wrapTitle'));
    var none=el('label','saga-gb__wrapnone');none.setAttribute('data-wrap','none');
    none.appendChild(radio(group,'none',units[i].wrap==='none'));none.appendChild(el('span',null,t('wrapNone')));
    box.appendChild(none);
    STYLES.forEach(function(k){grid.appendChild(wrapTile(k,radio(group,k,units[i].wrap===k)));});
    box.appendChild(grid);
    box.addEventListener('change',function(e){var r=e.target;if(r&&r.name===group&&r.checked){units[i].wrap=r.value;setErr(giftErr,'');}});
    return box;
  }
  /* several gift boxes: the two wrappings shown once, then one choice per box */
  function wrapRows(n){
    var box=el('div','saga-gb__wrapmany'),grid=el('div','saga-gb__wraps saga-gb__wraps--preview'),ul=el('ul','saga-gb__wraprows'),i;
    STYLES.forEach(function(k){grid.appendChild(wrapTile(k,null));});
    box.appendChild(grid);
    box.appendChild(el('p','saga-gift__hint',t('wrapLeadMany')));
    for(i=0;i<n;i++)(function(i){
      var li=el('li'),group='saga-wrap-'+i,opts=el('span','saga-gb__wrapopts');
      li.appendChild(el('span','saga-gb__wrapwho',labelFor(i)));
      opts.setAttribute('role','radiogroup');opts.setAttribute('aria-label',fill(t('wrapFor'),{'%s':labelFor(i)}));
      [['none',t('wrapNone')]].concat(STYLES.map(function(k){return [k,wrapName(k)];})).forEach(function(o){
        var lab=el('label','saga-gift__modeopt'),r=radio(group,o[0],units[i].wrap===o[0]);
        r.addEventListener('change',function(){if(r.checked){units[i].wrap=o[0];setErr(giftErr,'');}});
        lab.appendChild(r);lab.appendChild(el('span',null,o[1]));opts.appendChild(lab);
      });
      li.appendChild(opts);ul.appendChild(li);
    })(i);
    box.appendChild(ul);
    return box;
  }

  /* ---- card: the stocking card picker (Case 42/43/44), same galleries, same who-writes-it choice ---- */
  function field(i,key,label,placeholder,tag,wide){
    var lab=el('label','saga-gift__field'+(wide?' saga-gift__field--wide':''));
    lab.appendChild(el('span',null,label));
    var inp=el(tag);
    if(tag==='input')inp.type='text';
    inp.value=units[i][key];
    inp.placeholder=placeholder;
    inp.setAttribute('maxlength',key==='greeting'?'250':'40');
    inp.setAttribute('data-'+key,String(i));
    inp.addEventListener('input',function(){units[i][key]=inp.value;inp.classList.remove('is-missing');setErr(giftErr,'');});
    lab.appendChild(inp);
    return lab;
  }
  function cardPanel(i,stepped){
    var box=el('div','saga-gift__cardpanel'),cards=el('div','saga-gift__cards'),fields=el('div','saga-gift__fields'),mode=el('div','saga-gift__mode'),wantR=null;
    fields.hidden=!units[i].card||units[i].mode==='blank';
    mode.hidden=!units[i].card;
    function gallery(list){
      var gal=el('div','saga-gift__gallery');
      gal.setAttribute('role','radiogroup');gal.setAttribute('aria-label',fill(t('cardFor'),{'%s':labelFor(i)}));
      list.forEach(function(cd){
        var lab=el('label','saga-gift__tile'+(cd.code?'':' saga-gift__tile--none')),r=radio('saga-card-'+i,cd.code,units[i].card===cd.code);
        lab.addEventListener('mouseenter',function(){var g=gal.getBoundingClientRect(),b=lab.getBoundingClientRect();lab.style.setProperty('--saga-zoom-x',b.left-g.left<8?'0%':(g.right-b.right<8?'100%':'50%'));});
        lab.appendChild(r);
        var fr=el('span','saga-gift__frame'+(cd.image?'':' saga-gift__frame--none'));
        if(cd.image)fr.appendChild(img(cd.image));else fr.appendChild(icon());
        lab.appendChild(fr);
        lab.appendChild(el('span','saga-gift__tn',cd.label));
        r.addEventListener('change',function(){
          units[i].card=cd.code;mode.hidden=!cd.code;fields.hidden=!cd.code||units[i].mode==='blank';setErr(giftErr,'');
          if(stepped){units[i].want=cd.code?'yes':'no';box.setAttribute('data-want',units[i].want);if(wantR)wantR[units[i].want].checked=true;}
          var st=giftRoot.querySelector('[data-card-state="'+i+'"]');if(st)st.textContent=cd.label;
        });
        gal.appendChild(lab);
      });
      return gal;
    }
    var xmas=G.cards.filter(function(cd){return cd.set==='christmas';});
    cards.appendChild(gallery([{code:'',label:t('cardNone'),image:null}].concat(G.cards.filter(function(cd){return cd.set!=='christmas';}))));
    if(xmas.length){cards.appendChild(el('p','saga-gift__subhead',t('cardChristmasTitle')));cards.appendChild(gallery(xmas));}
    if(stepped){
      units[i].want=units[i].card?'yes':(units[i].want==='yes'?'yes':'no');
      box.setAttribute('data-want',units[i].want);
      var want=el('div','saga-gift__want');want.appendChild(el('span','saga-gift__wantq',t('cardWant')));
      wantR={};
      [['yes',t('cardWantYes')],['no',t('cardWantNo')]].forEach(function(o){
        var lab=el('label','saga-gift__modeopt'),r=radio('saga-cardwant-'+i,o[0],units[i].want===o[0]);wantR[o[0]]=r;
        r.addEventListener('change',function(){
          units[i].want=o[0];box.setAttribute('data-want',o[0]);
          if(o[0]==='no'){var none=box.querySelector('input[name="saga-card-'+i+'"][value=""]');if(none&&!none.checked){none.checked=true;none.dispatchEvent(new Event('change'));}}
        });
        lab.appendChild(r);lab.appendChild(el('span',null,o[1]));want.appendChild(lab);
      });
      box.appendChild(want);
    }
    box.appendChild(cards);
    [['blank',t('cardWriteSelf')],['handwritten',t('cardWriteSaga')]].forEach(function(o){
      var lab=el('label','saga-gift__modeopt'),r=radio('saga-cardmode-'+i,o[0],units[i].mode===o[0]);
      r.addEventListener('change',function(){units[i].mode=o[0];fields.hidden=o[0]==='blank';setErr(giftErr,'');});
      lab.appendChild(r);lab.appendChild(el('span',null,o[1]));mode.appendChild(lab);
    });
    box.appendChild(mode);
    fields.appendChild(field(i,'to',t('cardTo'),t('cardToPlaceholder'),'input',false));
    fields.appendChild(field(i,'from',t('cardFrom'),t('cardFromPlaceholder'),'input',false));
    fields.appendChild(field(i,'greeting',t('cardGreeting'),t('cardGreetingPlaceholder'),'textarea',true));
    box.appendChild(fields);
    return box;
  }
  function cardRow(i){
    var li=el('li'),who=el('span','saga-gift__who',labelFor(i));
    li.appendChild(who);
    var cur=cardByCode(units[i].card),st=el('span','saga-gift__state',cur?cur.label:t('cardNone'));
    st.setAttribute('data-card-state',String(i));li.appendChild(st);
    var btn=el('button','saga-gift__toggle',t('cardChoose')),panel=el('div','saga-gift__panel');
    btn.type='button';panel.hidden=!units[i].open;btn.setAttribute('aria-expanded',String(!!units[i].open));
    panel.setAttribute('data-card-panel',String(i));panel.id='saga-card-panel-'+i;btn.setAttribute('aria-controls',panel.id);
    btn.addEventListener('click',function(){units[i].open=panel.hidden;panel.hidden=!units[i].open;btn.setAttribute('aria-expanded',String(units[i].open));});
    li.appendChild(btn);
    panel.appendChild(cardPanel(i));
    li.appendChild(panel);
    return li;
  }

  function renderGift(){
    if(!giftRoot)return;
    var n=qty(),i;
    ensureUnits(n);
    giftRoot.innerHTML='';
    if(ITEMS.length)giftRoot.appendChild(namesSection(n));
    if(G.wrap&&STYLES.length){
      var sw=el('div','saga-gift__sec saga-gb__wrapsec');
      head(sw,t('wrapTitle'),fill(t('priceEach'),{'%p':money(G.wrap.price)}));
      sw.appendChild(lines(el('p','saga-gift__lead'),t('wrapLead')));
      sw.appendChild(n===1?wrapChoices(0):wrapRows(n));
      giftRoot.appendChild(sw);
    }
    if(G.card&&G.cards.length){
      var sc=el('div','saga-gift__sec');
      head(sc,t('cardTitle'),fill(t('priceEach'),{'%p':money(G.card.price)}));
      sc.appendChild(el('p','saga-gift__lead',t('cardLead')+' '+t('cardHandwritten')));
      if(n===1){sc.appendChild(cardPanel(0,true));}
      else{var ul=el('ul','saga-gift__rows saga-gift__rows--card');for(i=0;i<n;i++)ul.appendChild(cardRow(i));sc.appendChild(ul);}
      giftRoot.appendChild(sc);
    }
    giftErr=el('p','saga-gift__err');giftErr.setAttribute('role','alert');giftErr.hidden=true;giftRoot.appendChild(giftErr);
  }
  function mountGift(){
    giftRoot=el('div','saga-gift saga-gb');
    var btn=form.querySelector('button[type="submit"],button[name="add"]');
    if(btn&&btn.parentNode)btn.parentNode.insertBefore(giftRoot,btn);else form.appendChild(giftRoot);
    H.classList.add('saga-gb-on');
    renderGift();
  }

  /* ---- add to cart ---- */
  function openCart(){
    try{if(typeof window.SagaCartRefresh==='function'){if(window.SagaCartRefresh(true))return;}
        else{if(typeof window.SLIDECART_UPDATE==='function')window.SLIDECART_UPDATE();if(typeof window.SLIDECART_OPEN==='function'){window.SLIDECART_OPEN();return;}}}catch(x){}
    window.location.href=cartUrl();
  }
  function post(path,body){
    return fetch(path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body?JSON.stringify(body):undefined})
      .then(function(r){if(!r.ok)throw new Error('http '+r.status);return r.json();});
  }
  /* labels already used by gift lines in the cart, and the highest "Gift box n" */
  function usedLabels(cart){
    var used={},max=0;
    ((cart&&cart.items)||[]).forEach(function(it){
      var p=it.properties||{};
      if(!p._saga_gift_id)return;
      [p.Gift,p.For].forEach(function(v){
        if(!v)return;
        used[v]=true;
        var m=String(v).match(/^Gift box (\d+)/);if(m)max=Math.max(max,Number(m[1]));
      });
    });
    return {used:used,max:max};
  }
  function addAll(){
    var n=qty(),i,j,vid=variantId();
    setErr(giftErr,'');
    ensureUnits(n);
    if(!vid||rawQty()>MAXQ){setErr(giftErr,t('errorGeneric'));return;}
    /* a ticked item needs its name; a handwritten card needs its greeting */
    for(i=0;i<n;i++){
      var nd=namedOf(i);
      for(j=0;j<nd.length;j++){
        if(!nd[j].name){
          setErr(giftErr,fill(t('errorName'),{'%s':nd[j].item.phrase}));
          var ni=giftRoot.querySelector('[data-name="'+i+'-'+nd[j].j+'"]');
          if(ni){ni.classList.add('is-missing');ni.focus();}
          return;
        }
      }
      if(G.card&&units[i].card&&units[i].mode!=='blank'&&!String(units[i].greeting).trim()){
        setErr(giftErr,fill(t('cardErrorGreeting'),{'%s':labelFor(i)}));
        var pn=giftRoot.querySelector('[data-card-panel="'+i+'"]');
        if(pn&&pn.hidden){units[i].open=true;pn.hidden=false;}
        var gt=giftRoot.querySelector('[data-greeting="'+i+'"]');
        if(gt){gt.classList.add('is-missing');gt.focus();}
        return;
      }
    }
    giftRoot.classList.add('is-busy');
    (anyChoice()?post(cartUrl()+'.js').catch(function(){return null;}):Promise.resolve(null)).then(function(cart){
      var u0=usedLabels(cart),used=u0.used,seq=0,stamp=Date.now().toString(36),items=[];
      function unique(base){var l=base,k=2;while(used[l]){l=base+' ('+k+')';k++;}used[l]=true;return l;}
      for(i=0;i<n;i++){
        var u=units[i],named=namedOf(i),props={},gid='',lab='';
        var wrap=wrapOf(u),card=G.card&&u.card?cardByCode(u.card):null;
        if(named.length||wrap||card){seq++;lab=unique(DATA.box+(u0.max+seq));gid='g'+stamp+'-'+i;}
        if(lab){
          props['Gift']=lab;
          named.forEach(function(nd){props[nd.item.prop]=nd.name;});
          if(G.wrap){props['Gift wrapping']=wrap?'Yes':'No';if(wrap)props['Wrapping style']=DATA.wraps[wrap];}
          if(G.card)props['Greeting card']=card?'Yes':'No';
          if(card){
            props['Card name']=card.name;
            if(card.no)props['Card no.']=card.no;
            props['Card message']=u.mode==='blank'?DATA.cardBlank:DATA.cardHandwritten;
            if(u.mode!=='blank'){
              if(String(u.to).trim())props['To']=String(u.to).trim();
              if(String(u.from).trim())props['From']=String(u.from).trim();
              props['Greeting']=String(u.greeting).trim();
            }
          }
          if(named.length)props['_saga_names']=named.map(function(nd){return nd.item.prop;}).join('|');
          props['_saga_gift_id']=gid;
        }
        items.push({id:vid,quantity:1,properties:props});
        /* paid add-on lines: pricing and picking, tied to their box by the visible For label */
        named.forEach(function(nd){
          var np={'For':lab};np[nd.item.prop]=nd.name;np._saga_item=nd.item.prop;np._saga_gift_id=gid;np._saga_addon='name';
          items.push({id:G.name.variant,quantity:1,properties:np});
        });
        if(wrap)items.push({id:(DATA.wraps[wrap]==='Christmas Wrapping'&&G.wrap.variantChristmas)?G.wrap.variantChristmas:G.wrap.variant,quantity:1,properties:{'For':lab,'Wrapping style':DATA.wraps[wrap],'_saga_gift_id':gid,'_saga_addon':'wrap'}});
        if(card){
          var cp={'For':lab,'Card name':card.name};if(card.no)cp['Card no.']=card.no;
          ['Card message','To','From','Greeting'].forEach(function(k){if(props[k])cp[k]=props[k];});
          cp._saga_gift_id=gid;cp._saga_addon='card';
          items.push({id:G.card.variant,quantity:1,properties:cp});
        }
      }
      return post(R.cartAdd?R.cartAdd+'.js':shopRoot()+'cart/add.js',{items:items});
    })
      .then(function(){giftRoot.classList.remove('is-busy');if(typeof window.SagaCartCount==='function')window.SagaCartCount();openCart();})
      .catch(function(){giftRoot.classList.remove('is-busy');setErr(giftErr,t('errorAdd'));});
  }

  /* Capture phase on DOCUMENT beats any handler bound on the form, the button, Globo or GiftLab, so the
     hidden Globo fields never reach the cart from these pages. */
  document.addEventListener('click',function(e){
    var tg=e.target;if(!tg||!tg.closest||!giftRoot)return;
    var btn=tg.closest('button[type="submit"],input[type="submit"],button[name="add"]');
    if(!btn||!form.contains(btn))return;
    e.preventDefault();e.stopImmediatePropagation();addAll();
  },true);
  document.addEventListener('submit',function(e){
    if(e.target!==form||!giftRoot)return;
    e.preventDefault();e.stopImmediatePropagation();addAll();
  },true);

  function onQty(){renderGift();}
  if(qtyInput){
    qtyInput.addEventListener('input',onQty);
    qtyInput.addEventListener('change',onQty);
    var last=qtyInput.value;
    setInterval(function(){if(qtyInput.value!==last){last=qtyInput.value;onQty();}},400);
  }
  mountGift();
}catch(e){try{document.documentElement.classList.remove('saga-gb-on');}catch(x){}}})();
